const Cgi = {
  GetShopAgreementInfos: `https://${import.meta.env.VITE_API_HOST}/trpc.ecom.qqshop_cms_http_svr.QQShopCmsHttp/GetShopAgreementInfos`,
  GetShopAgreementInfo: `https://${import.meta.env.VITE_API_HOST}/trpc.ecom.qqshop_cms_http_svr.QQShopCmsHttp/GetShopAgreementInfo`,
  UpdateAgreementInfo: `https://${import.meta.env.VITE_API_HOST}/trpc.ecom.qqshop_cms_http_svr.QQShopCmsHttp/UpdateAgreementInfo`,
};
export { Cgi };
